import { SerializableObject } from '../data/serializable-object';

/**
 * Cache storage record interface
 */
export interface CacheRecord<T extends SerializableObject> {
  key: string;
  expire: Date | string;
  data: T;
}
